<script lang="ts" module>
  // Semantic toast/alert kinds. Callers pass one so success reads GREEN and errors RED, instead of
  // every alert defaulting to magenta (which made a "Crafted …" success look like a failure).
  export type ToastKind = "success" | "error" | "info";
</script>

<script lang="ts">
  import type { Snippet } from "svelte";

  let { kind = "info", children }: { kind?: ToastKind; children: Snippet } = $props();

  // success = lime (the "confirm" tertiary), error = magenta, info = cyan. A SOLID dark fill (not the
  // old translucent /15–/20 tint) so the neon text keeps ≥4.5:1 contrast over the busy world backdrop.
  const TONE: Record<ToastKind, string> = {
    success: "border-lime/55 text-lime glow-lime",
    error: "border-magenta/55 text-magenta glow-magenta",
    info: "border-cyan/50 text-cyan glow-cyan",
  };
</script>

<div class="chamfer-btn border bg-void-2/95 px-5 py-2.5 font-display text-sm font-semibold {TONE[kind]}" style="--c:8px">
  {@render children()}
</div>
